import axios from 'axios'
import {CampModel} from '../models/camp.model'
import {ResponseObjectPaginated} from '../../../../central/model'
const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

export function getCampsService(dto: CampModel, page: number) {
  return axios.post<ResponseObjectPaginated<CampModel[]>>(`${BASEURL}/camp/getAll/${page}`, dto)
}
